/* Jaiman Toys: tiny internal feedback buttons.
   Always on in unpublished/preview themes and in the Shopify theme editor.
   On the live theme it is hidden from customers: open any page with ?jtfb=1 to turn it on in your browser (?jtfb=0 turns it off).
   Submissions go to Creator Hub (Shopify admin > Apps > creator hub > Feedback) through ENDPOINT.
   Add a new feature: append a row to FEATURES below, or put data-jt-feedback="feature-id"
   (and optional data-jt-feedback-label="Name") on any element in the theme. */
(function () {
  if (window.__jtFeedback) return;
  window.__jtFeedback = true;

  var ENDPOINT = 'https://jaiman-creator-hub-production.up.railway.app/api/feedback';
  var TOKEN = 'jtfb-8f3k2q9x7m'; /* must match TOKEN in app/routes/api.feedback.jsx */
  var KEY = 'jt_fb_on', NAME_KEY = 'jt_fb_name';

  function enabled() {
    try {
      var q = new URLSearchParams(location.search).get('jtfb');
      if (q === '1') localStorage.setItem(KEY, '1');
      if (q === '0') localStorage.removeItem(KEY);
      if (localStorage.getItem(KEY) === '1') return true;
    } catch (e) {}
    if (window.Shopify) {
      if (Shopify.designMode) return true;
      if (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') return true;
    }
    return false;
  }
  if (!enabled()) return;

  var FEATURES = [
    { id: 'cart-empty-launchpad', label: 'Cart: empty-cart launchpad', sel: '.jt-cu__hero' },
    { id: 'cart-delivery-progress', label: 'Cart: free-delivery progress bar', sel: '.jt-cu__ship' },
    { id: 'cart-coupons', label: 'Cart: coupon list', sel: '.jt-cu__offers' },
    { id: 'cart-item-cards', label: 'Cart: item cards', sel: '#main-cart-items' },
    { id: 'cart-summary-checkout', label: 'Cart: order summary and checkout', sel: '#main-cart-footer .cart__blocks' },
    { id: 'cart-related-products', label: 'Cart: You might also like', sel: '.jt-cu__recs' },
    { id: 'cart-whatsapp-help', label: 'Cart: WhatsApp help card', sel: '.jt-cu__help' },
    { id: 'cart-collectors-corner', label: 'Cart: Collectors corner', sel: '.jt-cu__collect' },
    { id: 'collection-load-more', label: 'Collection: Load more products button', sel: '.load-more-wrap', inline: true }
  ];

  var css = '.jtfb-chip{position:absolute;top:8px;right:8px;z-index:20;width:24px;height:24px;padding:0;border-radius:50%;border:1px dashed #8c4c9e;background:rgba(255,255,255,.95);color:#8c4c9e;opacity:.7;cursor:pointer;display:grid;place-items:center;transition:opacity .2s,transform .2s}' +
    '.jtfb-chip:hover,.jtfb-chip:focus-visible{opacity:1;transform:scale(1.15)}' +
    '.jtfb-chip svg{width:13px;height:13px}' +
    '.jtfb-inline{position:static;display:inline-grid;margin-left:10px;vertical-align:middle}' +
    '.jtfb-pill{position:fixed;left:12px;bottom:12px;z-index:99999;background:#242833;color:#fff;border-radius:999px;padding:6px 12px;font:700 11px/1 Nunito,Inter,sans-serif;letter-spacing:.08em;text-transform:uppercase;opacity:.85}' +
    '.jtfb-pill b{color:#25d366}' +
    '.jtfb-panel{position:fixed;right:16px;bottom:16px;width:min(330px,calc(100vw - 32px));z-index:100000;background:#fff;color:#121212;border:1px solid #e4dff0;border-radius:16px;box-shadow:0 18px 50px -12px rgba(36,40,51,.45);padding:14px;font:14px/1.4 Nunito,Inter,sans-serif}' +
    '.jtfb-h{display:flex;align-items:flex-start;gap:8px;margin-bottom:10px}' +
    '.jtfb-h div{flex:1;min-width:0}.jtfb-h b{display:block;font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#8c4c9e}' +
    '.jtfb-h span{font-weight:700}' +
    '.jtfb-x{border:0;background:none;font-size:22px;line-height:1;cursor:pointer;color:#6b6577}' +
    '.jtfb-types{display:flex;gap:6px;margin-bottom:8px;flex-wrap:wrap}' +
    '.jtfb-types button{border:1px solid #e4dff0;background:#fff;border-radius:999px;padding:5px 12px;font:inherit;font-size:13px;cursor:pointer}' +
    '.jtfb-types button[aria-pressed=true]{background:#242833;color:#fff;border-color:#242833}' +
    '.jtfb-panel textarea,.jtfb-panel input{width:100%;border:1px solid #e4dff0;border-radius:10px;padding:8px 10px;font:inherit;margin-bottom:8px;background:#fff;color:#121212}' +
    '.jtfb-acts{display:flex;gap:8px}' +
    '.jtfb-acts button{flex:1;border:0;border-radius:10px;padding:9px;font:inherit;font-weight:700;cursor:pointer}' +
    '.jtfb-acts button:disabled{opacity:.5;cursor:default}' +
    '.jtfb-send{background:#242833;color:#fff}.jtfb-copy{background:#f5f0ff;color:#8c4c9e;flex:0 0 auto!important}' +
    '.jtfb-msg{margin:8px 0 0;font-size:12px;color:#2f9e6a;min-height:1em}.jtfb-msg.err{color:#d6453d}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L3 21l1.9-5.4A8 8 0 1 1 21 12z"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function closePanel() {
    var p = document.querySelector('.jtfb-panel');
    if (p) p.remove();
  }

  function payload(f, type, note, who) {
    var theme = (window.Shopify && Shopify.theme && Shopify.theme.name) ? Shopify.theme.name + ' (#' + Shopify.theme.id + ')' : 'unknown';
    return {
      token: TOKEN,
      label: f.label,
      id: f.id,
      type: type || 'Not set',
      note: note || '',
      who: who || '',
      page: location.href.replace(/([?&])jtfb=[^&]*&?/, '$1'),
      theme: theme,
      screen: innerWidth + 'x' + innerHeight + ' (' + (innerWidth < 750 ? 'mobile' : 'desktop') + ')'
    };
  }

  function asText(d) {
    return '[Jaiman Toys feedback]\nFeature: ' + d.label + ' (' + d.id + ')\nType: ' + d.type + '\nNote: ' + (d.note || '-') +
      '\nFrom: ' + (d.who || '-') + '\nPage: ' + d.page + '\nTheme: ' + d.theme + '\nScreen: ' + d.screen;
  }

  function openPanel(f) {
    closePanel();
    var who = '';
    try { who = localStorage.getItem(NAME_KEY) || ''; } catch (e) {}
    var p = document.createElement('div');
    p.className = 'jtfb-panel';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-label', 'Internal feedback');
    p.innerHTML = '<div class="jtfb-h"><div><b>Internal feedback</b><span>' + esc(f.label) + '</span></div><button type="button" class="jtfb-x" aria-label="Close">&times;</button></div>' +
      '<div class="jtfb-types"><button type="button" data-t="Works well">Works well</button><button type="button" data-t="Problem">Problem</button><button type="button" data-t="Idea">Idea</button></div>' +
      '<textarea rows="3" placeholder="What did you notice?" aria-label="Feedback note"></textarea>' +
      '<input type="text" placeholder="Your name" aria-label="Your name" value="' + esc(who) + '">' +
      '<div class="jtfb-acts"><button type="button" class="jtfb-send">Send feedback</button><button type="button" class="jtfb-copy">Copy</button></div>' +
      '<p class="jtfb-msg" role="status"></p>';
    document.body.appendChild(p);

    var type = '', ta = p.querySelector('textarea'), nm = p.querySelector('input'), msg = p.querySelector('.jtfb-msg'), send = p.querySelector('.jtfb-send');
    function build() {
      try { localStorage.setItem(NAME_KEY, nm.value.trim()); } catch (e) {}
      return payload(f, type, ta.value.trim(), nm.value.trim());
    }
    function say(t, bad) { msg.textContent = t; msg.className = 'jtfb-msg' + (bad ? ' err' : ''); }

    p.querySelector('.jtfb-x').onclick = closePanel;
    p.querySelectorAll('.jtfb-types button').forEach(function (b) {
      b.onclick = function () {
        type = b.getAttribute('data-t');
        p.querySelectorAll('.jtfb-types button').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      };
    });
    send.onclick = function () {
      var d = build();
      if (!type && !d.note) { say('Pick a type or write a note first.', true); return; }
      if (!ENDPOINT) { say('Backend is not connected yet. Use Copy for now.', true); return; }
      send.disabled = true;
      say('Sending...');
      /* text/plain keeps this a simple request (no CORS preflight); the server allows jaimantoys.com to read the reply */
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(d) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !j.ok) throw new Error(j.error || 'failed');
          });
        })
        .then(function () {
          say('Sent. Thank you.');
          ta.value = '';
          setTimeout(closePanel, 1400);
        })
        .catch(function () {
          send.disabled = false;
          say('Could not send. Try again, or use Copy.', true);
        });
    };
    p.querySelector('.jtfb-copy').onclick = function () {
      var t = asText(build());
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () {
        say('Copied.');
      }, function () { ta.value = t; ta.select(); say('Press Ctrl+C to copy.'); });
    };
    ta.focus();
  }

  function addChip(el, f) {
    if (el.getAttribute('data-jt-fb-on')) return;
    el.setAttribute('data-jt-fb-on', '1');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'jtfb-chip' + (f.inline ? ' jtfb-inline' : '');
    b.title = 'Internal feedback: ' + f.label;
    b.setAttribute('aria-label', 'Internal feedback: ' + f.label);
    b.innerHTML = ICON;
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPanel(f); });
    if (!f.inline && getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.appendChild(b);
  }

  function scan() {
    FEATURES.forEach(function (f) {
      document.querySelectorAll(f.sel).forEach(function (el) { addChip(el, f); });
    });
    document.querySelectorAll('[data-jt-feedback]').forEach(function (el) {
      var id = el.getAttribute('data-jt-feedback');
      addChip(el, { id: id, label: el.getAttribute('data-jt-feedback-label') || id });
    });
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(scan, 250); }
  function start() {
    var pill = document.createElement('div');
    pill.className = 'jtfb-pill';
    pill.innerHTML = '<b>&#9679;</b> Feedback mode';
    document.body.appendChild(pill);
    scan();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();